import { UI_GroupContent, UI_GroupHeader, UI_GroupWrapper } from "../../../PanelStyle";
import { LuChevronDown, LuChevronUp } from "react-icons/lu";
import { memo, useState, useEffect, useCallback } from "react";
import { useAtom } from 'jotai';
import { Element_Base } from "~/common/typescript/models/Element";
import ElementItem from "./ElementItem";
import { elementsAtom, elementSearchTextAtom } from "~/components/Map/Element/ElementStore";
import { Input } from "antd";
import styled from "styled-components";

const ElementGroup = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [elements, setElements] = useAtom<Element_Base[]>(elementsAtom);
  const [localSearchText, setLocalSearchText] = useState('');
  const [searchText, setSearchText] = useAtom(elementSearchTextAtom);
  const [filteredItems, setFilteredItems] = useState<Element_Base[]>([]);

  const debouncedSetSearchText = useCallback(
    debounce((value: string) => {
      setSearchText(value);
    }, 300),
    []
  );

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setLocalSearchText(value);
    debouncedSetSearchText(value);
  };

  useEffect(() => {
    let result = elements.filter((element) => !element.is_deleted);
    
    if (searchText.trim()) {
      const searchLower = searchText.toLowerCase().trim();
      result = result.filter((element) => {
        const name = element.name || '';
        return name.toLowerCase().includes(searchLower) || 
               element.uuid.toLowerCase().includes(searchLower);
      });
    }
    
    setFilteredItems(result);
  }, [elements, searchText]);

  return (
    <UI_GroupWrapper>
      <UI_GroupHeader onClick={() => setIsOpen(!isOpen)}>
        <span>Đối tượng ({filteredItems.length})</span>
        <span>
          {isOpen ? <LuChevronDown /> : <LuChevronUp />}
        </span>
      </UI_GroupHeader>
      <UI_GroupContent style={{ display: isOpen ? 'block' : 'none' }}>
        <UI_SearchWrapper>
          <Input.Search
            placeholder="Tìm kiếm đối tượng..."
            value={localSearchText}
            onChange={handleSearchChange}
            allowClear
            onClick={(e) => e.stopPropagation()}
          />
        </UI_SearchWrapper>
        {filteredItems.map((element) => {
          return <ElementItem key={element.uuid} element={element} />;
        })}

        {
          filteredItems.length === 0 && (
            <div style={{ textAlign: 'center', padding: 20, color: '#666' }}>
              {searchText.trim() ? 'Không tìm thấy đối tượng' : 'Chưa có đối tượng nào'}
            </div>
          )
        }
      </UI_GroupContent>
    </UI_GroupWrapper>)
};

function debounce<T extends (...args: any[]) => any>(func: T, wait: number): (...args: Parameters<T>) => void {
  let timeoutId: ReturnType<typeof setTimeout> | null = null;
  return (...args: Parameters<T>) => {
    if (timeoutId) clearTimeout(timeoutId);
    timeoutId = setTimeout(() => func(...args), wait);
  };
}

export default memo(ElementGroup);

const UI_SearchWrapper = styled.div`
  padding: 4px 0;
  margin-bottom: 4px;
`;